import {
  AgxSpacer,
  AgxTypography,
  Icon_Email,
  Icon_PhoneOutline,
} from '@urbanx/agx.ui-components2';
import { ReactNode } from 'react';
import CopyableContactValue from './CopyableContactValue';

interface ContactDetailsProps {
  id: string;
  name?: string;
  role?: string;
  email?: string;
  phone?: string;
  badge?: ReactNode;
  compact?: boolean;
  emptyMessage?: string;
}

const ContactDetails = ({
  id,
  name,
  role,
  email,
  phone,
  badge,
  compact = false,
  emptyMessage = 'No contact details recorded',
}: ContactDetailsProps) => {
  const hasContactDetails = Boolean(name || email || phone);

  return (
    <AgxSpacer gap="spacing-md" style={{ minWidth: 0 }}>
      <AgxSpacer
        direction="horizontal"
        contentAlignment="center"
        gap="spacing-md"
        wrap
        style={{ minWidth: 0 }}
      >
        {hasContactDetails ? (
          name && (
            <AgxTypography
              id={`${id}-name`}
              type={compact ? 'body_ui' : 'body_ui_strong'}
              size="medium"
            >
              {name}
              {role && <span className="campaignOverviewContactRole"> ({role})</span>}
            </AgxTypography>
          )
        ) : (
          <AgxTypography
            id={`${id}-empty`}
            type="body_ui"
            size="medium"
            color="var(--text-tertiary)"
          >
            {emptyMessage}
          </AgxTypography>
        )}
        {badge}
      </AgxSpacer>
      {(email || phone) && (
        <AgxSpacer contentAlignment="start" gap="spacing-xs" style={{ minWidth: 0 }}>
          {email && (
            <CopyableContactValue
              id={`${id}-email`}
              value={email}
              href={`mailto:${email}`}
              icon={<Icon_Email width={12} height={12} color="var(--fg-tertiary)" />}
            />
          )}
          {phone && (
            <CopyableContactValue
              id={`${id}-phone`}
              value={phone}
              href={`tel:${phone}`}
              icon={<Icon_PhoneOutline width={14} height={14} color="var(--fg-tertiary)" />}
            />
          )}
        </AgxSpacer>
      )}
    </AgxSpacer>
  );
};

export default ContactDetails;
